import React from 'react';
import styled, { css } from 'styled-components';

import { Icon } from 'ui/components/shared';
import { spacing } from 'ui/theme/utils';

export const DownloadButton = ({ children, ...rest }) => (
  <StyledButton {...rest}>
    <Icon icon="pdf-file" alt="download" mr="7px" />
    {children}
  </StyledButton>
);

const disabledOpacity = 0.5;

export const StyledButton = styled.button`
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ bg = '#e6eeff' }) => bg};
  color: ${({ theme }) => theme.colors.primary};
  padding: ${({ padding = '9px 20px' }) => padding};
  font-size: ${({ fontSize = '15px' }) => fontSize};
  font-weight: ${({ fontWeight = 500 }) => fontWeight};
  letter-spacing: 0.7px;
  border-radius: 5px;
  text-align: center;
  &:hover {
    opacity: ${({ disabled }) => (disabled ? disabledOpacity : '0.9')};
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: ${disabledOpacity};
      cursor: ${({ disabledCursor = 'not-allowed' }) => disabledCursor};
    `}
  ${(props) => spacing(props)}
`;
